/**
 * Provider-related constants for the BiteWise healthcare platform
 */

/**
 * Provider role options for registration and validation
 */
export const PROVIDER_ROLE_OPTIONS = [
  { value: '', label: 'Select a role', disabled: false },
  { value: 'gp', label: 'GP (General Practitioner)', disabled: false },
  { value: 'specialist', label: 'Specialist', disabled: false },
  { value: 'surgeon', label: 'Surgeon', disabled: false },
  { value: 'nurse', label: 'Nurse', disabled: false }
] as const;

/**
 * Valid provider role values (excluding empty placeholder)
 */
export const VALID_PROVIDER_ROLES = PROVIDER_ROLE_OPTIONS
  .filter(option => option.value !== '')
  .map(option => option.value);

/**
 * Type for provider role values
 */
export type ProviderRole = typeof VALID_PROVIDER_ROLES[number];